import api, { ValidateAxiosError } from '@/modules/api.service';

export interface MunicipioIBGE {
  id: number;
  nome: string;
  microrregiao: {
    id: number;
    nome: string;
    mesorregiao: {
      id: number;
      nome: string;
      UF: {
        id: number;
        sigla: string;
        nome: string;
      };
    };
  };
}

export class MunicipioService {
  async getMunicipiosSergipe(): Promise<MunicipioIBGE[]> {
    try {
      const response = await api.get<MunicipioIBGE[]>('/municipio/sergipe');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao buscar municípios.');
    }
  }
}

